// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';
import { Actions, ActionTypes } from './actions';
import { initialState, NotificationState } from './state';

/**
 * This effect is for listen master notification actions, execute auth service call and dispatch in master notification reducer.
 * For master notification api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 27/4/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created master notification effect
 */
export function reducer(state = initialState, action: Actions | AuthActions): NotificationState {
  switch (action.type) {
    // NOTIFICATION_COMMON ACTION METHOD
    case ActionTypes.NOTIFICATION_COMMON: {
      return state;
    }
    // NOTIFICATION_COMMON_SUCCESS ACTION METHOD
    case ActionTypes.NOTIFICATION_COMMON_SUCCESS: {

      // commonly store and handle all master notification modules
      if (action.response.common.INDIVIDUAL) {
        const response = get(action.response.data, action.response.common.API_RESPONSE);
        return {
          ...state,
          [action.response.common.STATE]: {
            ...state[action.response.common.STATE],
            [response[action.response.common.UNIQUE_KEY]]: response,
          },
        };
      }

      // store as normal way
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      console.log('logout');
      return initialState;
    }

    // DEFAULT
    default:
      return state;
  }
}
